import React from 'react';
import { useIntl } from 'react-intl';
import classNames, { Argument } from 'classnames';

import { useSelector } from 'hooks';
import useCurrentStep from 'hooks/useCurrentStep';
import { getSelectedLanguage } from 'modules/translations/selectors';

import Button, { ButtonType } from '../Button';
import Flag from './components/Flags';
import LanguageSelectModal from './Modal';

interface LanguageSelectProps {
  className?: Argument;
}

const LanguageSelect: React.FC<LanguageSelectProps> = ({ className }) => {
  const intl = useIntl();
  const locale = useSelector(getSelectedLanguage);
  const currentStep = useCurrentStep();
  const [isOpen, setIsOpen] = React.useState(false);

  const handleOpenModal = () => setIsOpen(true);
  const handleCloseModal = () => setIsOpen(false);

  return (
    <div className="py-3 kiosk:py-10 z-50" data-testid="language-select">
      <Button
        className={classNames('size-10 kiosk:size-20 p-0! kiosk:p-2! flex items-center justify-center btn-header', className)}
        aria-label={intl.formatMessage({ id: 'helpLine.changeLanguage', defaultMessage: 'Change language' })}
        onClick={handleOpenModal}
        type={ButtonType.ICON}
        testId="language-select-button"
        analytics={{
          category: 'Language',
          action: 'Language select button',
          label: `Language select opened from ${currentStep}`,
        }}
      >
        <Flag locale={locale} className="w-8 h-auto kiosk:w-16 kiosk:h-auto aspect-btn-header-flag rounded-btn-header-flag! btn-header-flag" />
      </Button>
      <LanguageSelectModal open={isOpen} onClose={handleCloseModal} />
    </div>
  );
};

export default LanguageSelect;
